module.exports = __webpack_public_path__ + "static/media/icon_keyanzheng.a857fec0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_keyanzheng.svg
// module id = 135
// module chunks = 0